import Vue from 'vue';
import { VT } from '@/store/types';

export default {
  // [VT.TAGS_TREE]: (state, { type, data, status }) => {
  //   state.classifiersTree[type] = { data: data, status };
  //   state.classifiersTree.status = status;
  // },

  [VT.TAGS_FLUSH]: (state) => {
    state.cache = {};
  },

  [VT.TAGS_LOAD]: (state, { data }) => {
    if (!state.cached) {
      const cachable = {
        list: data.data.map((e) => {
          e.label = `${e.name}`; // TODO this could use all translations, currently used for searching as translations are used for display
          e.pathArr = e.path.split(',').map(Number);
          e.pathArr.pop();
          return e;
        }),
        hash: null, // data.hash,
        idx: {},
        childs: {}
      };
      cachable.list.forEach((el, idx) => {
        // For easy lookup by id
        cachable.idx[el.id] = idx;
        // For easy child lookup by parent id
        const parentId = el.parent_id || 0;
        if (!Object.prototype.hasOwnProperty.call(cachable.childs, parentId)) cachable.childs[parentId] = [];
        cachable.childs[parentId].push(el.id);
      });

      state.cache = cachable;
      state.cached = true;
      console.log("TAGS_LOAD | state cache loaded!");
    }
    else {
      console.log("TAGS_LOAD | tag cache already loaded...");
    }
    // Vue.set(state.cache, type, cachable);
  },
};
